import { render, staticRenderFns } from "./CollapsedText.vue?vue&type=template&id=e49a7dfe&"
import script from "./CollapsedText.vue?vue&type=script&lang=js&"
export * from "./CollapsedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports